import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/concepts/$conceptId/")({
  component: () => {
    const { conceptId } = Route.useParams();
    return (
      <Navigate
        to="/concepts/$conceptId/curate"
        params={{ conceptId }}
      />
    );
  },
});
